module.exports = __webpack_public_path__ + "static/media/icon_up_gray.3dc84d63.svg";